import { Box, CircularProgress, Typography } from "@mui/material";
import React from "react";
import { Link, Navigate } from "react-router-dom";
import { useDownloadUsers } from "./DownloadUsersContext";
import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";

const DownloadUserList = () => {
  const {
    downloadAllUserAcc,
    setSelectedDownloadUserAcc,
    authenticationChecked,
  } = useDownloadUsers();
  const [error, setError] = React.useState("");

  const viewEditLinkIcon = (item) => {
    return (
      <Link
        className="hyper-links"
        onClick={(e) => setSelectedDownloadUserAcc(item)}
      >
        {item.id}
      </Link>
    );
  };
  const dispRoles = (userAcc) => {
    return userAcc.roles.map((eachrole, idx) => {
      return eachrole + "\n";
    });
  };

  const convertDateISOToUTC = (isoDate) => {
    if (isoDate !== null && isoDate !== "") {
      const date = new Date(isoDate);
      const utcFormatted = `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, "0")}-${String(date.getUTCDate()).padStart(2, "0")} ${String(date.getUTCHours()).padStart(2, "0")}:${String(date.getUTCMinutes()).padStart(2, "0")}:${String(date.getUTCSeconds()).padStart(2, "0")}`;
      return utcFormatted;
    } else return "";
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport />
        <div style={{ flex: 1 }} />
        <GridToolbarQuickFilter />
      </GridToolbarContainer>
    );
  }

  const dataGridColumns = [
    {
      field: "id",
      headerName: "ID",
      filterable: true,
      sortable: true,
      flex: 0.2,
      minWidth: 100,
      renderCell: (params) => viewEditLinkIcon(params.row),
    },
    {
      field: "login",
      headerName: "Login",
      filterable: true,
      sortable: true,
      flex: 0.2,
      minWidth: 100,
    },
    {
      field: "name",
      headerName: "Name",
      filterable: true,
      sortable: true,
      flex: 0.2,
      minWidth: 100,
    },
    {
      field: "organization",
      headerName: "Organization",
      filterable: true,
      sortable: true,
      flex: 0.2,
      minWidth: 100,
    },
    {
      field: "email",
      headerName: "Email",
      filterable: true,
      sortable: true,
      flex: 0.2,
      minWidth: 100,
    },
    {
      field: "roles",
      headerName: "Role",
      filterable: true,
      sortable: true,
      flex: 0.2,
      minWidth: 140,
      renderCell: (params) => dispRoles(params.row),
    },
    {
      field: "agreementSent",
      headerName: "Agreement Sent",
      filterable: true,
      sortable: true,
      flex: 0.2,
      minWidth: 150,
      renderCell: (params) => convertDateISOToUTC(params.row.agreementSent),
    },
    {
      field: "agreementReceived",
      headerName: "Agreement Received",
      filterable: true,
      sortable: true,
      flex: 0.2,
      minWidth: 150,
      renderCell: (params) => convertDateISOToUTC(params.row.agreementReceived),
    },
    {
      field: "approved",
      headerName: "Approved",
      filterable: true,
      sortable: true,
      flex: 0.2,
      minWidth: 150,
      renderCell: (params) => convertDateISOToUTC(params.row.approved),
    },
    {
      field: "updated",
      headerName: "Updated",
      filterable: true,
      sortable: true,
      flex: 0.2,
      minWidth: 150,
      renderCell: (params) => convertDateISOToUTC(params.row.updated),
    },
  ];

  if (downloadAllUserAcc !== null) {
    if (downloadAllUserAcc.length > 0)
      return (
        <>
          <Typography variant="h5" sx={{ mb: 2, textAlign: "center", mt: 2 }}>
            {" "}
            Manage Download User Accounts{" "}
          </Typography>
          <DataGrid
            rows={downloadAllUserAcc}
            columns={dataGridColumns}
            components={{
              Toolbar: CustomToolbar,
            }}
            disableSelectionOnClick
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                fontSize: "1rem",
                fontWeight: "bold",
                display: "flex",
              },

              "& .MuiDataGrid-cell": {
                whiteSpace: "normal",
                wordWrap: "break-word",
                lineHeight: "1.2em",
              },
            }}
          />
        </>
      );
    else
      return (
        <Typography sx={{ textAlign: "center", m: 2 }} variant="h5">
          {error ? error : "No Data Found"}
        </Typography>
      );
  } else {
    if (authenticationChecked === "Success") {
      return (
        <Box sx={{ width: "100%", textAlign: "center" }}>
          <CircularProgress />
        </Box>
      );
    }
    if (authenticationChecked === "UNAUTHORIZED") {
      const wasAdminLoggedIn = sessionStorage.getItem("isAdmin") === "true";
      const isUserLoggedIn = sessionStorage.getItem("isUser") === "true";
      if (isUserLoggedIn)
        return (
          <Typography sx={{ textAlign: "center", m: 2 }} variant="h6">
            You are not authorized to view this page.
          </Typography>
        );
      else if (wasAdminLoggedIn)
        return (
          <Typography sx={{ textAlign: "center", m: 2 }} variant="h6">
            Session expired.{" "}
            <Link to="/About/AdminLogin" className="hyper-links">
              <b>Click here to log back in</b>
            </Link>
          </Typography>
        );
      else return <Navigate to="/About/AdminLogin" replace />;
    }
    if (authenticationChecked === "FORBIDDEN")
      return <Navigate to="/About/AdminLogin" replace />;
  }
};

export default DownloadUserList;
